

const IFRAME_ALLOW = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";

const createPlayer = (container) => {
    const { videoKind, videoSrc, videoTitle, videoVimeo } = container.dataset;
    const vimeoClass = videoVimeo === "true" ? " video-thumbnail--vimeo" : "";

    if (videoKind === "embed") {
        const iframe = document.createElement("iframe");
        iframe.className = `video-thumbnail__video${vimeoClass}`;
        iframe.src = videoSrc;
        iframe.title = videoTitle || "";
        iframe.width = "100%";
        iframe.allow = IFRAME_ALLOW;
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.allowFullscreen = true;
        return iframe;
    }

    const video = document.createElement("video");
    video.className = "video-thumbnail__video video-thumbnail__video-element";
    video.controls = true;
    video.autoplay = true;
    video.setAttribute("aria-label", videoTitle || "");
    const source = document.createElement("source");
    source.src = videoSrc;
    video.appendChild(source);
    return video;
};

const play = (container) => {
    if (container.dataset.videoPlaying) {
        return;
    }
    container.dataset.videoPlaying = "true";
    const player = createPlayer(container);
    container.replaceChildren(player);
    player.focus();
};

export default function videoThumbnail() {
    document.querySelectorAll("[data-nova-video]").forEach((container) => {
        container.addEventListener("click", () => play(container));
    });
}
